(function () {
  if (window.__LB_ROUTINE_FINDER_AI_LOADED__) return;
  window.__LB_ROUTINE_FINDER_AI_LOADED__ = true;

  var root = document.getElementById("lb-routine-finder-ai");
  var configEl = document.getElementById("lb-routine-finder-ai-config");

  if (!root || !configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent || "{}");
  } catch (error) {
    config = {};
  }

  var endpoint = root.getAttribute("data-endpoint") || "https://ladybonita-ai-proxy.web-businesstown.workers.dev/";
  var sessionKey = "lb_routine_finder_session_id";
  var conversationKey = "lb_routine_finder_conversation_id";
  var resultStateKey = "lb_routine_finder_result_v2";
  var catalogCacheKey = "lb_routine_finder_catalog_v2";
  var catalogCacheMaxAge = 30 * 60 * 1000;

  var answers = {};
  var currentStep = 0;
  var lastResult = null;
  var selectedMainRoutine = [];
  var recommendedProducts = [];
  var allProducts = [];
  var lastMarketingConsent = false;
  var lastMarketingConsentTimestamp = "";

  var iconBottle = '<svg viewBox="0 0 24 24" fill="none"><path d="M8 3h8l1 4H7l1-4Z" fill="currentColor" opacity=".16"/><path d="M7 7h10l-1 14H8L7 7Z" stroke="currentColor" stroke-width="1.7"/><path d="M10 11h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var iconDrop = '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3c2.8 3.3 5 6.3 5 10a5 5 0 0 1-10 0c0-3.7 2.2-6.7 5-10Z" stroke="currentColor" stroke-width="1.7"/><path d="M9.5 14.5c.6 1.2 1.4 1.8 2.5 1.8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var iconHeart = '<svg viewBox="0 0 24 24" fill="none"><path d="M12 21s7-4.2 7-11a4 4 0 0 0-7-2.6A4 4 0 0 0 5 10c0 6.8 7 11 7 11Z" stroke="currentColor" stroke-width="1.7"/><path d="M12 8v8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var iconSparkle = '<svg viewBox="0 0 24 24" fill="none"><path d="M12 2l1.8 5.8L20 10l-6.2 2.2L12 18l-1.8-5.8L4 10l6.2-2.2L12 2Z" stroke="currentColor" stroke-width="1.7"/></svg>';
  var iconTarget = '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12c3.8-7.8 10.2-7.8 14 0-3.8 7.8-10.2 7.8-14 0Z" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="2.5" stroke="currentColor" stroke-width="1.7"/></svg>';

  function makeId(prefix) {
    return prefix + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function getSessionId() {
    try {
      var existing = localStorage.getItem(sessionKey);
      if (existing) return existing;
      var created = makeId("lb_rf_session");
      localStorage.setItem(sessionKey, created);
      return created;
    } catch (error) {
      return makeId("lb_rf_session");
    }
  }

  function getConversationId() {
    try {
      var existing = sessionStorage.getItem(conversationKey);
      if (existing) return existing;
      var created = makeId("lb_rf_conversation");
      sessionStorage.setItem(conversationKey, created);
      return created;
    } catch (error) {
      return makeId("lb_rf_conversation");
    }
  }

  var sessionId = getSessionId();
  var conversationId = getConversationId();

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function stripHtml(html) {
    var div = document.createElement("div");
    div.innerHTML = String(html || "");
    return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
  }

  function normalizeText(value) {
    return String(value || "").toLowerCase().replace(/[^\w\s-]/g, " ").replace(/\s+/g, " ").trim();
  }

  function formatMoney(price) {
    if (price === null || price === undefined || price === "") return "";
    var raw = String(price).replace(/[^\d.]/g, "");
    if (!raw) return "";
    var number = Number(raw);
    if (Number.isNaN(number)) return "";
    if (number > 1000 && String(price).indexOf(".") === -1) number = number / 100;
    return "NZ$" + number.toFixed(2);
  }

  function getHandleFromUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var match = parsed.pathname.match(/\/products\/([^\/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      var fallback = String(url || "").match(/\/products\/([^\/?#]+)/);
      return fallback && fallback[1] ? decodeURIComponent(fallback[1]) : "";
    }
  }

  function getProductText(product) {
    return normalizeText([
      product.title,
      product.vendor,
      product.productType,
      product.tags,
      product.description
    ].join(" "));
  }

  function renderShell() {
    root.innerHTML =
      '<section class="lb-rf">' +
        '<div class="lb-rf-bg-blobs" aria-hidden="true"><div class="lb-rf-blob one"></div><div class="lb-rf-blob two"></div><div class="lb-rf-blob three"></div></div>' +
        '<div class="lb-rf-page">' +
          '<section class="lb-rf-hero">' +
            '<div class="lb-rf-panel lb-rf-hero-copy">' +
              '<div class="lb-rf-kicker">Routine Finder</div>' +
              '<h1>Find your skincare match</h1>' +
              '<p>Not sure where to start? Answer a few quick questions and discover a routine that suits your skin, your goals and the way you like to use skincare.</p>' +
              '<div class="lb-rf-actions">' +
                '<button class="lb-rf-btn lb-rf-btn-primary" type="button" data-lb-rf-start>Start quiz</button>' +
              '</div>' +
            '</div>' +
            '<div class="lb-rf-panel lb-rf-visual" aria-label="Skincare routine visual preview">' +
              '<div class="lb-rf-orbit" aria-hidden="true"></div>' +
              '<div class="lb-rf-floating-card cleanse"><div class="lb-rf-icon-tile" aria-hidden="true">' + iconBottle + '</div><div><strong>Cleanse softly</strong><span>Fresh skin without making your routine feel complicated.</span></div></div>' +
              '<div class="lb-rf-floating-card glow"><div class="lb-rf-icon-tile" aria-hidden="true">' + iconDrop + '</div><div><strong>Treat your goal</strong><span>A serum, essence or ampoule chosen around your main concern.</span></div></div>' +
              '<div class="lb-rf-floating-card comfort"><div class="lb-rf-icon-tile" aria-hidden="true">' + iconHeart + '</div><div><strong>Finish comfortably</strong><span>Moisture support that fits your texture preference.</span></div></div>' +
              '<div class="lb-rf-mini-note"><span>Made to match your skin goals</span><strong>Routine · Pairings · Extras</strong></div>' +
            '</div>' +
          '</section>' +
          renderMarquee() +
          '<section class="lb-rf-panel lb-rf-quiz" id="lb-rf-quiz-panel">' +
            '<div class="lb-rf-progress-wrap">' +
              '<div class="lb-rf-progress-meta"><span data-lb-rf-progress-label>Question 1 of 7</span><span>Quick, guided and easy to answer</span></div>' +
              '<div class="lb-rf-progress"><div class="lb-rf-progress-bar" data-lb-rf-progress-bar></div></div>' +
            '</div>' +
            '<form data-lb-rf-form>' + renderStepSkinType() + renderStepMainConcern() + renderStepSensitivity() + renderStepProductGoal() + renderStepRoutineLevel() + renderStepTexture() + renderStepFreeNote() + '</form>' +
            '<div class="lb-rf-loading" data-lb-rf-loading><div class="lb-rf-loading-card"><div class="lb-rf-loader" aria-hidden="true"></div><strong>Finding your skincare match...</strong><span style="color: var(--lb-muted); font-size: 13px; line-height: 1.45;">Checking your answers and preparing routine ideas, complementary picks and extras.</span></div></div>' +
            '<div class="lb-rf-error" data-lb-rf-error></div>' +
          '</section>' +
          '<section class="lb-rf-results" data-lb-rf-results></section>' +
        '</div>' +
      '</section>';
  }

  function renderMarquee() {
    var items = [
      { title: "Cleanse", text: "Start fresh without overcomplicating your routine.", icon: iconBottle },
      { title: "Hydrate", text: "Light layers for comfort, glow and softness.", icon: iconDrop },
      { title: "Calm", text: "Gentle picks for skin that feels easily stressed.", icon: iconHeart },
      { title: "Glow", text: "Options for dullness, dark spots or uneven tone.", icon: iconSparkle },
      { title: "Target", text: "Serums, ampoules and extras around your skin goal.", icon: iconTarget }
    ];

    return '<section class="lb-rf-image-marquee" aria-label="Routine preview categories"><div class="lb-rf-marquee-track">' + items.concat(items).map(function (item) {
      return '<div class="lb-rf-marquee-card"><div class="lb-rf-marquee-icon">' + item.icon + '</div><b>' + escapeHtml(item.title) + '</b><span>' + escapeHtml(item.text) + '</span></div>';
    }).join("") + '</div></section>';
  }

  function renderStepSkinType() {
    return renderStep(0, "How does your skin usually feel?", "Choose the closest match on most days. If your skin changes depending on weather, hormones or season, pick what happens most often.", "skinType", [
      ["oily", "Oily", "Shiny through the day, visible pores or frequent breakouts."],
      ["dry", "Dry", "Tight, flaky, dull or uncomfortable after cleansing."],
      ["combination", "Combination", "Oily T-zone, but cheeks can feel normal or dry."],
      ["balanced", "Balanced", "Usually comfortable, with only occasional concerns."],
      ["not_sure", "Not sure", "No problem — we’ll guide the routine using your next answers."]
    ], false);
  }

  function renderStepMainConcern() {
    return renderStep(1, "What would you most like to improve?", "Pick your main goal for now. This helps keep your result clear, instead of recommending too many things at once.", "mainConcern", [
      ["hydration", "Hydration & glow", "Skin feels dehydrated, dull or needs a plumper look."],
      ["breakouts", "Breakouts & blemishes", "Spots, congestion, uneven texture or post-breakout marks."],
      ["brightening", "Brightening & dark spots", "Dullness, uneven-looking tone or pigmentation-looking areas."],
      ["calm", "Calm & comfort", "Skin that looks red, feels reactive or stings easily."],
      ["pores_oil", "Pores & oil control", "Shine, visible pores or makeup separating quickly."],
      ["barrier", "Barrier support", "Skin feels weak, tight, over-exfoliated or easily irritated."],
      ["firmness", "Firmness & fine lines", "You want smoother-looking, more supported skin."],
      ["not_sure", "Not sure", "Choose this if you simply want a good starter routine."]
    ], true);
  }

  function renderStepSensitivity() {
    return renderStep(2, "How easily does your skin react?", "This helps the routine stay gentle when needed. It is not medical advice — it just helps us avoid suggestions that may feel too strong.", "sensitivity", [
      ["low", "Not sensitive", "I can usually try new skincare without issues."],
      ["medium", "A little sensitive", "I avoid some ingredients or introduce products slowly."],
      ["high", "Very sensitive", "My skin reacts easily, so I prefer gentle options where possible."],
      ["not_sure", "Not sure", "Choose this and we’ll keep your result on the gentler side."]
    ], true);
  }

  function renderStepProductGoal() {
    return renderStep(3, "What are you looking for today?", "Choose the kind of help you want. If you want a complete suggestion, choose full routine.", "productGoal", [
      ["cleanser", "Cleanser", "Something to start the routine and cleanse comfortably."],
      ["toner_essence", "Toner / essence", "A light layer for hydration, balance or prep."],
      ["serum_ampoule", "Serum / ampoule", "A targeted product for your main skin goal."],
      ["moisturiser", "Moisturiser", "To seal hydration and support comfort."],
      ["mask_patch", "Mask / patches / extras", "Extra care for hydration, blemishes or weekly support."],
      ["full_routine", "Full routine", "Let us build a complete starter routine."]
    ], true);
  }

  function renderStepRoutineLevel() {
    return renderStep(4, "How many steps feel realistic?", "This keeps your result practical. You can always explore more options in the extra sections after your main routine.", "routineLevel", [
      ["simple", "Simple", "2–3 steps. Easy to follow and not overwhelming."],
      ["balanced", "Balanced", "3–5 steps. Helpful, but still realistic."],
      ["full", "Full K-beauty", "I enjoy layering and want a more complete routine."]
    ], true);
  }

  function renderStepTexture() {
    return renderStep(5, "Any texture preference?", "Pick what usually feels better on your skin. If you are unsure, choose no preference.", "texture", [
      ["lightweight", "Lightweight", "Gel, watery, fresh or fast-absorbing textures."],
      ["nourishing", "Nourishing", "Creamier, comforting products for softness and barrier feel."],
      ["no_preference", "No preference", "I’m happy for the routine to choose the best fit."]
    ], true);
  }

  function renderStep(stepIndex, title, helper, name, options, showBack) {
    var optionsHtml = options.map(function (option) {
      return '<button type="button" class="lb-rf-option" data-lb-rf-option data-name="' + escapeHtml(name) + '" data-value="' + escapeHtml(option[0]) + '"><b>' + escapeHtml(option[1]) + '</b><span>' + escapeHtml(option[2]) + '</span></button>';
    }).join("");

    return '<div class="lb-rf-step' + (stepIndex === 0 ? " is-active" : "") + '" data-lb-rf-step="' + stepIndex + '">' +
      '<h2>' + escapeHtml(title) + '</h2>' +
      '<p class="lb-rf-helper">' + escapeHtml(helper) + '</p>' +
      '<div class="lb-rf-options">' + optionsHtml + '</div>' +
      '<div class="lb-rf-step-actions">' +
        (showBack ? '<button class="lb-rf-btn lb-rf-btn-secondary" type="button" data-lb-rf-back>Back</button>' : '<span></span>') +
        '<button class="lb-rf-btn lb-rf-btn-primary" type="button" data-lb-rf-next>Next</button>' +
      '</div>' +
    '</div>';
  }

  function renderStepFreeNote() {
    return '<div class="lb-rf-step" data-lb-rf-step="6">' +
      '<h2>Anything else we should know?</h2>' +
      '<p class="lb-rf-helper">Optional, but helpful. You can write naturally, like you would tell a beauty assistant. This can help with AM/PM ideas, patches, textures or what you have tried before.</p>' +
      '<div class="lb-rf-free-note">' +
        '<textarea data-lb-rf-free-note placeholder="Example: My skin gets oily by afternoon but still feels dehydrated. I want something for night time and maybe pimple patches too."></textarea>' +
        '<div class="lb-rf-writing-help" aria-label="What to write guidance">' +
          '<div class="lb-rf-writing-help-card"><b>When you want to use it</b>Morning, evening, both, or only a weekly extra.</div>' +
          '<div class="lb-rf-writing-help-card"><b>What you like or avoid</b>Lightweight, non-sticky, fragrance-free, rich creams, exfoliating products.</div>' +
          '<div class="lb-rf-writing-help-card"><b>What you already use</b>A cleanser, toner, serum, cream or active you want to keep using.</div>' +
          '<div class="lb-rf-writing-help-card"><b>Extras you want</b>Pimple patches, masks, lip care, eye care or something calming.</div>' +
        '</div>' +
        '<div class="lb-rf-example-chips" aria-label="Example notes">' +
          '<button type="button" class="lb-rf-chip" data-lb-rf-fill="I want a simple morning routine.">Morning routine</button>' +
          '<button type="button" class="lb-rf-chip" data-lb-rf-fill="I want something for night time and barrier support.">Night support</button>' +
          '<button type="button" class="lb-rf-chip" data-lb-rf-fill="I also want patches or small extras for blemishes.">Patches / extras</button>' +
          '<button type="button" class="lb-rf-chip" data-lb-rf-fill="I prefer lightweight products that do not feel sticky.">Lightweight feel</button>' +
        '</div>' +
      '</div>' +
      '<div class="lb-rf-step-actions"><button class="lb-rf-btn lb-rf-btn-secondary" type="button" data-lb-rf-back>Back</button><button class="lb-rf-btn lb-rf-btn-primary" type="button" data-lb-rf-results-trigger>Show my routine</button></div>' +
    '</div>';
  }

  function renderStepEmail() {
    return "";
  }

  function bindEvents() {
    root.addEventListener("click", function (event) {
      var start = event.target.closest("[data-lb-rf-start]");
      if (start) {
        scrollToQuiz();
        trackQuizEvent("quiz_started", { notes: "Started from hero button" });
        return;
      }



      var option = event.target.closest("[data-lb-rf-option]");
      if (option) {
        selectOption(option);
        return;
      }

      var next = event.target.closest("[data-lb-rf-next]");
      if (next) {
        goNext();
        return;
      }

      var back = event.target.closest("[data-lb-rf-back]");
      if (back) {
        goBack();
        return;
      }

      var fill = event.target.closest("[data-lb-rf-fill]");
      if (fill) {
        var textarea = root.querySelector("[data-lb-rf-free-note]");
        if (textarea) {
          textarea.value = fill.getAttribute("data-lb-rf-fill") || "";
          textarea.focus();
        }
        return;
      }

      var results = event.target.closest("[data-lb-rf-results-trigger], [data-lb-rf-skip-results]");
      if (results) {
        generateResults(false);
        return;
      }

      var edit = event.target.closest("[data-lb-rf-edit]");
      if (edit) {
        currentStep = 0;
        updateStep();
        hideResults();
        showQuizForm();
        showQuizPanel();
        scrollToQuiz();
        return;
      }

      var qtyMinus = event.target.closest("[data-lb-rf-qty-minus]");
      if (qtyMinus) {
        changeQuantity(qtyMinus, -1);
        return;
      }

      var qtyPlus = event.target.closest("[data-lb-rf-qty-plus]");
      if (qtyPlus) {
        changeQuantity(qtyPlus, 1);
        return;
      }

      var productAdd = event.target.closest("[data-lb-rf-add]");
      if (productAdd) {
        addSingleToCart(productAdd);
        return;
      }

      var addAll = event.target.closest("[data-lb-rf-add-all]");
      if (addAll) {
        addAllMainRoutine(addAll);
        return;
      }

      var saveScroll = event.target.closest("[data-lb-rf-scroll-save]");
      if (saveScroll) {
        scrollToSaveCard();
        return;
      }

      var saveEmail = event.target.closest("[data-lb-rf-save-email]");
      if (saveEmail) {
        requestEmailResult(saveEmail);
        return;
      }

      var heart = event.target.closest("[data-lb-rf-heart]");
      if (heart) {
        toggleLocalWishlist(heart);
        return;
      }

      var showMore = event.target.closest("[data-lb-rf-show-more]");
      if (showMore) {
        showMoreProducts(showMore);
        return;
      }

      var carouselPrev = event.target.closest("[data-lb-rf-carousel-prev]");
      if (carouselPrev) {
        scrollBrandCarousel(-1);
        return;
      }

      var carouselNext = event.target.closest("[data-lb-rf-carousel-next]");
      if (carouselNext) {
        scrollBrandCarousel(1);
        return;
      }

      var viewProduct = event.target.closest("[data-lb-rf-view-product]");
      if (viewProduct) {
        trackQuizEvent("quiz_view_product", {
          productTitle: viewProduct.getAttribute("data-title") || "",
          productUrl: viewProduct.getAttribute("href") || "",
          notes: JSON.stringify({ section: viewProduct.getAttribute("data-section") || "" })
        });
      }
    });

    root.addEventListener("change", function (event) {
      if (event.target.matches("[data-lb-rf-qty]")) {
        event.target.value = clampQuantity(event.target.value);
      }
    });
  }

  function scrollToQuiz() {
    var panel = root.querySelector("#lb-rf-quiz-panel");
    if (panel) panel.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function selectOption(option) {
    var name = option.getAttribute("data-name");
    var value = option.getAttribute("data-value");

    root.querySelectorAll('[data-lb-rf-option][data-name="' + name + '"]').forEach(function (item) {
      item.classList.remove("is-selected");
    });

    option.classList.add("is-selected");
    answers[name] = value;

    trackQuizEvent("quiz_step_answered", {
      question: name,
      answer: value
    });
  }

  function goNext() {
    if (currentStep <= 5) {
      var active = root.querySelector('[data-lb-rf-step="' + currentStep + '"]');
      var selected = active ? active.querySelector(".lb-rf-option.is-selected") : null;

      if (!selected) {
        shakeStep(active);
        return;
      }
    }

    if (currentStep === 6) {
      var freeNote = root.querySelector("[data-lb-rf-free-note]");
      answers.freeNote = freeNote ? freeNote.value.trim() : "";
      if (answers.freeNote) {
        trackQuizEvent("quiz_step_answered", {
          question: "freeNote",
          answer: answers.freeNote
        });
      }
    }

    if (currentStep >= 6) {
      generateResults(false);
      return;
    }

    currentStep = Math.min(currentStep + 1, 6);
    updateStep();
  }

  function goBack() {
    currentStep = Math.max(currentStep - 1, 0);
    updateStep();
  }

  function updateStep() {
    root.querySelectorAll("[data-lb-rf-step]").forEach(function (step) {
      step.classList.toggle("is-active", Number(step.getAttribute("data-lb-rf-step")) === currentStep);
    });

    var bar = root.querySelector("[data-lb-rf-progress-bar]");
    var label = root.querySelector("[data-lb-rf-progress-label]");

    if (bar) bar.style.width = ((currentStep + 1) / 7 * 100) + "%";
    if (label) label.textContent = "Question " + Math.min(currentStep + 1, 7) + " of 7";
  }

  function shakeStep(step) {
    if (!step || !step.animate) return;
    step.animate([
      { transform: "translateX(0)" },
      { transform: "translateX(-5px)" },
      { transform: "translateX(5px)" },
      { transform: "translateX(0)" }
    ], { duration: 260 });
  }

  function showLoading(isLoading) {
    var loading = root.querySelector("[data-lb-rf-loading]");
    var form = root.querySelector("[data-lb-rf-form]");
    var error = root.querySelector("[data-lb-rf-error]");

    if (loading) loading.classList.toggle("is-active", isLoading);
    if (form) form.style.display = isLoading ? "none" : "";
    if (error) error.classList.remove("is-active");
  }

  function showError(message) {
    var error = root.querySelector("[data-lb-rf-error]");
    var form = root.querySelector("[data-lb-rf-form]");
    var loading = root.querySelector("[data-lb-rf-loading]");

    if (loading) loading.classList.remove("is-active");
    if (form) form.style.display = "";

    if (error) {
      error.textContent = message;
      error.classList.add("is-active");
    }
  }

  function hideResults() {
    var results = root.querySelector("[data-lb-rf-results]");
    if (results) results.classList.remove("is-active");
  }

  function hideQuizForm() {
    var form = root.querySelector("[data-lb-rf-form]");
    var loading = root.querySelector("[data-lb-rf-loading]");
    if (form) form.style.display = "none";
    if (loading) loading.classList.remove("is-active");
  }

  function showQuizForm() {
    var form = root.querySelector("[data-lb-rf-form]");
    if (form) form.style.display = "";
  }

  function hideQuizPanel() {
    var panel = root.querySelector("#lb-rf-quiz-panel");
    if (panel) panel.style.display = "none";
  }

  function showQuizPanel() {
    var panel = root.querySelector("#lb-rf-quiz-panel");
    if (panel) panel.style.display = "";
  }

  function getResultSummary(result) {
    var source = String((result && (result.customerSummary || result.aiSkinProfile)) || "").replace(/\s+/g, " ").trim();
    if (!source) {
      return "A personalised skincare routine selected around your quiz answers.";
    }

    source = source.replace(/^you\s+have\s+/i, "").replace(/^your\s+/i, "");
    if (source.length <= 140) return source;

    var cut = source.slice(0, 140);
    var punctuationIndex = Math.max(cut.lastIndexOf("."), cut.lastIndexOf(";"), cut.lastIndexOf(","), cut.lastIndexOf("—"));
    if (punctuationIndex > 80) {
      cut = cut.slice(0, punctuationIndex);
    } else {
      cut = cut.slice(0, cut.lastIndexOf(" "));
    }
    return cut.replace(/[\s,;:-]+$/, "") + ".";
  }

  function scrollToSaveCard() {
    var saveCard = root.querySelector(".lb-rf-save-card");
    if (saveCard) {
      saveCard.scrollIntoView({ behavior: "smooth", block: "center" });
      var input = root.querySelector("[data-lb-rf-save-email-input]");
      if (input) input.focus();
    }
  }

  async function generateResults(shouldEmail) {
    var emailInput = root.querySelector("[data-lb-rf-email]");
    var customerEmail = emailInput ? emailInput.value.trim() : "";

    answers.freeNote = (root.querySelector("[data-lb-rf-free-note]") || {}).value || "";
    answers.freeNote = String(answers.freeNote || "").trim();

    if (shouldEmail && customerEmail && !isValidEmail(customerEmail)) {
      showError("Please enter a valid email address, or choose Skip — show results.");
      return;
    }

    showLoading(true);

    try {
      var catalog = await loadAllProducts();
      var candidates = selectCandidateProducts(catalog, answers);

      if (!candidates.length) {
        showQuizPanel();
      showError("Sorry, we could not find matching products right now. Please try again or contact our team for help.");
        return;
      }

      var payload = {
        mode: "quiz",
        sessionId: sessionId,
        conversationId: conversationId,
        customerEmail: customerEmail,
        pageUrl: window.location.href,
        quizAnswers: Object.assign({}, answers),
        candidateProducts: candidates
      };

      var response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      var data = await response.json();

      if (!response.ok || !data.ok || !data.result) {
        showQuizPanel();
        showError("Sorry, the quiz could not generate your result just now. Please try again shortly.");
        return;
      }

      lastResult = data.result;
      selectedMainRoutine = Array.isArray(lastResult.mainRoutineProducts) ? lastResult.mainRoutineProducts : [];
      recommendedProducts = collectRecommendedProducts(lastResult);
      renderResult(lastResult, customerEmail);
      showLoading(false);
      hideQuizForm();
      hideQuizPanel();

      trackQuizEvent("quiz_completed", {
        customerEmail: customerEmail,
        notes: JSON.stringify({ candidates: candidates.length })
      });

      try {
        sessionStorage.setItem(resultStateKey, JSON.stringify({
          result: lastResult,
          answers: answers,
          email: customerEmail,
          time: Date.now()
        }));
      } catch (error) {}

      if (customerEmail) {
        await markCartAttributes(customerEmail);
      }

      if (shouldEmail && customerEmail) {
        await sendQuizEmail(customerEmail);
      }

      var resultsPanel = root.querySelector("[data-lb-rf-results]");
      if (resultsPanel) resultsPanel.scrollIntoView({ behavior: "smooth", block: "start" });
    } catch (error) {
      console.error("[Lady Bonita Routine Finder] Result generation failed:", error);
      showQuizPanel();
      showError("Sorry, something went wrong while building your routine. Please try again.");
    }
  }

  function renderResult(result, customerEmail) {
    var results = root.querySelector("[data-lb-rf-results]");
    if (!results) return;

    var mainRoutine = Array.isArray(result.mainRoutineProducts) ? result.mainRoutineProducts : [];
    var alsoLike = Array.isArray(result.youMayAlsoLikeProducts) ? result.youMayAlsoLikeProducts : [];
    var pairings = Array.isArray(result.pairingSets) ? result.pairingSets : [];
    var brands = Array.isArray(result.brandProducts) ? result.brandProducts : [];
    var summary = getResultSummary(result);

    results.innerHTML =
      '<div class="lb-rf-panel lb-rf-results-card">' +
        '<div class="lb-rf-profile-card">' +
          '<div class="lb-rf-profile-icon">🌸</div>' +
          '<div class="lb-rf-profile-copy">' +
            '<div class="lb-rf-match-label">Routine Finder result</div>' +
            '<h2>Your Routine Match</h2>' +
            '<p>' + escapeHtml(summary) + '</p>' +
            '<div class="lb-rf-result-toolbar">' +
              '<button class="lb-rf-btn lb-rf-btn-secondary" type="button" data-lb-rf-edit>Edit answers</button>' +
              '<button class="lb-rf-btn lb-rf-btn-pink" type="button" data-lb-rf-scroll-save>Email my routine</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        renderMainRoutine(mainRoutine) +
        renderYouMayAlsoLike(alsoLike) +
        renderPairings(pairings) +
        renderAmPmNotes(result.amPmNotes, mainRoutine) +
        renderBrandProducts(getExtraBrandProducts(brands, mainRoutine, alsoLike, pairings)) +
        renderSaveCard(customerEmail) +
        renderPreOrderCard() +
        '<p class="lb-rf-disclaimer">' + escapeHtml(result.safetyNote || "General guidance only. Not clinical advice. Product information may be updated by the manufacturer, so please check product pages and packaging for the latest instructions and ingredients. Patch test skincare before use.") + '</p>' +
      '</div>';

    results.classList.add("is-active");
    initWishlistEngine();
  }

  function renderSectionHeader(config) {
    var action = config.action || "";
    return '<div class="lb-rf-section-title lb-rf-section-title-upgraded">' +
      '<div>' +
        '<span class="lb-rf-section-eyebrow">' + escapeHtml(config.eyebrow || "Recommended") + '</span>' +
        '<h3>' + escapeHtml(config.title || "") + '</h3>' +
        '<p>' + escapeHtml(config.description || "") + '</p>' +
      '</div>' +
      (action ? '<div class="lb-rf-section-action">' + action + '</div>' : '') +
    '</div>';
  }

  function renderMainRoutine(products) {
    return renderSectionHeader({
        eyebrow: "Start here",
        title: "Your suggested routine",
        description: "The core products selected for your skin goal, arranged in a simple flow.",
        action: '<button class="lb-rf-btn lb-rf-btn-secondary" type="button" data-lb-rf-add-all>Add selected to cart</button>'
      }) +
      '<div class="lb-rf-grid" data-lb-rf-main-grid>' + (products.length ? products.map(function (product) { return renderProductCard(product, "main_routine"); }).join("") : '<div class="lb-rf-empty">No main routine products were found.</div>') + '</div>';
  }

  function renderYouMayAlsoLike(products) {
    if (!products.length) return "";

    var items = products.slice(0, 8).map(function (product) {
      return '<div class="lb-rf-carousel-item">' + renderProductCard(product, "you_may_also_like") + '</div>';
    }).join("");

    return renderSectionHeader({
        eyebrow: "Explore more",
        title: "You may also like",
        description: "Extra options that match the same skin goal, texture preference or routine style.",
        action: ""
      }) +
      '<div class="lb-rf-carousel-hint lb-rf-mobile-only">Swipe sideways →</div>' +
      '<div class="lb-rf-brand-carousel-shell lb-rf-yml-carousel-shell">' +
        '<div class="lb-rf-brand-carousel lb-rf-yml-carousel" data-lb-rf-more-row>' + items + '</div>' +
      '</div>';
  }

  function renderPairingProduct(product, setTitle) {
    var url = escapeHtml(product.url || window.location.origin);
    var title = escapeHtml(product.title || "Product");
    var image = product.image
      ? '<img loading="lazy" src="' + escapeHtml(product.image) + '" alt="' + title + '" onerror="this.style.display=\'none\';">'
      : getProductIcon(product);
    var meta = [product.vendor, product.priceText].filter(Boolean).join(" · ");
    var reason = product.reason || product.benefit || ("Works with this set to support the " + String(setTitle || "routine").toLowerCase() + ".");
    var variantId = escapeHtml(product.variantId || "");
    var add = product.available === false || !variantId
      ? '<a class="lb-rf-mini-link" href="' + url + '" data-lb-rf-view-product data-section="pairing_products" data-title="' + title + '">View</a>'
      : '<button class="lb-rf-mini-link" type="button" data-lb-rf-add data-section="pairing_products" data-variant-id="' + variantId + '" data-title="' + title + '">Add</button>';

    return '<div class="lb-rf-pair-product" data-lb-rf-product-card data-section="pairing_products" data-variant-id="' + variantId + '" data-title="' + title + '" data-url="' + url + '" data-price="' + escapeHtml(product.priceText || "") + '">' +
      '<a class="lb-rf-pair-image" href="' + url + '" data-lb-rf-view-product data-section="pairing_products" data-title="' + title + '">' + image + '</a>' +
      '<div class="lb-rf-pair-info">' +
        '<strong>' + title + '</strong>' +
        '<span>' + escapeHtml(meta) + '</span>' +
        '<p>' + escapeHtml(reason) + '</p>' +
        '<div class="lb-rf-pair-actions">' + add + '<a class="lb-rf-mini-link secondary" href="' + url + '" data-lb-rf-view-product data-section="pairing_products" data-title="' + title + '">View</a></div>' +
      '</div>' +
    '</div>';
  }

  function renderPairings(pairings) {
    if (!pairings.length) return "";

    var html = pairings.map(function (set) {
      var miniItems = (set.products || []).slice(0, 3).map(function (product) {
        return renderPairingProduct(product, set.title || "Pairs well with");
      }).join("");

      return '<article class="lb-rf-set-card lb-rf-set-card-upgraded">' +
        '<span class="lb-rf-step-pill">Pairs well with</span>' +
        '<h4>' + escapeHtml(set.title || "Product pairing") + '</h4>' +
        '<p>' + escapeHtml(set.reason || "These products can complement each other in the same routine.") + '</p>' +
        '<div class="lb-rf-set-products">' + miniItems + '</div>' +
      '</article>';
    }).join("");

    return renderSectionHeader({
        eyebrow: "Good together",
        title: "Pairs well with",
        description: "Helpful combinations from your result, so you can see how products complement each other.",
        action: ""
      }) + '<div class="lb-rf-grid two">' + html + '</div>';
  }

  function selectRoutineTimingProducts(products, time) {
    var output = [];
    (products || []).forEach(function (product) {
      var timing = normalizeText(product.timing || product.step || product.productType || product.title || "");
      var title = normalizeText(product.title || "");
      var joined = timing + " " + title;
      var isCleanser = /cleanser|cleansing|wash|foam/.test(joined);
      var isMoist = /moistur|cream|gel cream|lotion|barrier/.test(joined);
      var isTreat = /serum|ampoule|essence|toner|treat|mask|patch|exfoliat/.test(joined);

      if (time === "am") {
        if (/am|morning|both|day/.test(timing) || isCleanser || isMoist || /toner|essence|hydr/.test(joined)) output.push(product);
      } else {
        if (/pm|evening|night|both/.test(timing) || isCleanser || isTreat || isMoist) output.push(product);
      }
    });

    if (!output.length) output = (products || []).slice(0, 4);
    return output.slice(0, 5);
  }

  function renderRoutineLine(products) {
    if (!products || !products.length) {
      return '<span class="lb-rf-routine-chip">Your selected products</span>';
    }

    return products.map(function (product, index) {
      return '<span class="lb-rf-routine-chip"><b>' + (index + 1) + '</b>' + escapeHtml(product.title || "Product") + '</span>';
    }).join('<span class="lb-rf-routine-arrow">→</span>');
  }

  function renderAmPmNotes(notes, products) {
    if (!notes && (!products || !products.length)) return "";
    var amText = extractAmNote(notes || "");
    var pmText = extractPmNote(notes || "");
    var amProducts = selectRoutineTimingProducts(products || [], "am");
    var pmProducts = selectRoutineTimingProducts(products || [], "pm");

    return renderSectionHeader({
        eyebrow: "How to use",
        title: "Morning and evening ideas",
        description: "A simple way to place your recommended products into a routine.",
        action: ""
      }) +
      '<div class="lb-rf-am-pm">' +
        '<article class="lb-rf-tip-card morning"><span class="lb-rf-step-pill">Morning</span><h4>AM routine idea</h4><div class="lb-rf-routine-line">' + renderRoutineLine(amProducts) + '</div><p>' + escapeHtml(amText) + '</p></article>' +
        '<article class="lb-rf-tip-card evening"><span class="lb-rf-step-pill">Evening</span><h4>PM routine idea</h4><div class="lb-rf-routine-line">' + renderRoutineLine(pmProducts) + '</div><p>' + escapeHtml(pmText) + '</p></article>' +
      '</div>';
  }

  function extractAmNote(notes) {
    var text = String(notes || "");
    var sentences = text.split(/(?<=[.!?])\s+/);
    var am = sentences.filter(function (sentence) { return /morning|am|day|sunscreen|spf/i.test(sentence); }).join(" ");
    return am || text;
  }

  function extractPmNote(notes) {
    var text = String(notes || "");
    var sentences = text.split(/(?<=[.!?])\s+/);
    var pm = sentences.filter(function (sentence) { return /evening|pm|night|overnight|mask|patch|treatment/i.test(sentence); }).join(" ");
    return pm || text;
  }

  function scrollBrandCarousel(direction) {
    var carousel = root.querySelector("[data-lb-rf-brand-carousel]");
    if (!carousel) return;

    var amount = Math.max(280, carousel.clientWidth * 0.82);
    carousel.scrollBy({
      left: amount * direction,
      behavior: "smooth"
    });
  }

  function getExtraBrandProducts(existingProducts, mainRoutine, alsoLike, pairings) {
    var output = [];
    var seen = new Set();

    function addSeen(product) {
      var key = normalizeProductKey(product);
      if (key) seen.add(key);
    }

    function addProduct(product) {
      if (!product || !product.title || !product.url) return;
      var key = normalizeProductKey(product);
      if (!key || seen.has(key)) return;
      seen.add(key);
      output.push(product);
    }

    (mainRoutine || []).forEach(addSeen);
    (alsoLike || []).forEach(addSeen);
    (pairings || []).forEach(function (set) {
      (set.products || []).forEach(addSeen);
    });
    (existingProducts || []).forEach(addProduct);

    var preferredVendors = [];
    (mainRoutine || []).concat(alsoLike || []).forEach(function (product) {
      var vendor = normalizeText(product.vendor || "");
      if (vendor && preferredVendors.indexOf(vendor) === -1) preferredVendors.push(vendor);
    });

    var preferredTypes = [];
    (mainRoutine || []).concat(alsoLike || []).forEach(function (product) {
      var type = normalizeText(product.productType || product.step || "");
      if (type && preferredTypes.indexOf(type) === -1) preferredTypes.push(type);
    });

    var sourceProducts = Array.isArray(allProducts) ? allProducts : [];

    sourceProducts.forEach(function (product) {
      if (output.length >= 16) return;
      var vendor = normalizeText(product.vendor || "");
      if (vendor && preferredVendors.indexOf(vendor) !== -1) addProduct(product);
    });

    sourceProducts.forEach(function (product) {
      if (output.length >= 16) return;
      var type = normalizeText(product.productType || product.title || product.tags || "");
      var matchesType = preferredTypes.some(function (preferredType) {
        return preferredType && type.indexOf(preferredType) !== -1;
      });
      if (matchesType) addProduct(product);
    });

    sourceProducts.forEach(function (product) {
      if (output.length >= 16) return;
      addProduct(product);
    });

    return output.slice(0, 16);
  }

  function normalizeProductKey(product) {
    if (!product) return "";
    return normalizeText(product.variantId || product.id || product.url || product.handle || product.title || "");
  }

  function renderBrandProducts(products) {
    if (!products.length) return "";
    var items = products.slice(0, 16).map(function (product) {
      return '<div class="lb-rf-carousel-item">' + renderProductCard(product, "brand_products") + '</div>';
    }).join("");

    var desktopControls =
      '<button class="lb-rf-carousel-arrow lb-rf-carousel-arrow-left" type="button" aria-label="Previous brand products" data-lb-rf-carousel-prev>‹</button>' +
      '<button class="lb-rf-carousel-arrow lb-rf-carousel-arrow-right" type="button" aria-label="Next brand products" data-lb-rf-carousel-next>›</button>';

    return renderSectionHeader({
        eyebrow: "Brand matches",
        title: "More from brands you may like",
        description: "More product options from brands connected to your result.",
        action: ""
      }) +
      '<div class="lb-rf-carousel-hint lb-rf-mobile-only">Swipe sideways →</div>' +
      '<div class="lb-rf-brand-carousel-shell">' +
        desktopControls +
        '<div class="lb-rf-brand-carousel" data-lb-rf-brand-carousel>' + items + '</div>' +
      '</div>';
  }

  function renderSaveCard(customerEmail) {
    return '<div class="lb-rf-save-card lb-rf-save-card-reward">' +
      '<div class="lb-rf-save-copy">' +
        '<span class="lb-rf-reward-pill">Routine reward</span>' +
        '<h3>🫶 Save your beauty routine &amp; enjoy 5% off</h3>' +
        '<p>Get your personalised Lady Bonita routine by email and receive a 5% off reward code for your next order over $99.</p>' +
        '<div class="lb-rf-status" data-lb-rf-save-status></div>' +
      '</div>' +
      '<div class="lb-rf-save-form">' +
        '<div class="lb-rf-save-email-row">' +
          '<input class="lb-rf-email-input" type="email" data-lb-rf-save-email-input placeholder="Email address" value="' + escapeHtml(customerEmail || "") + '">' +
          '<button class="lb-rf-btn lb-rf-btn-primary" type="button" data-lb-rf-save-email>Email my routine</button>' +
        '</div>' +
        '<label class="lb-rf-consent-row">' +
          '<input type="checkbox" data-lb-rf-marketing-consent>' +
          '<span>I’d like to receive occasional Lady Bonita exclusive offers by email.</span>' +
        '</label>' +
        '<p class="lb-rf-save-terms">Terms &amp; Conditions: 5% discount valid on orders over $99. Code valid for 15 days. Single-use code only. One active code per customer at a time. Cannot be used with other discount codes or promotions unless stated otherwise. Excludes gift cards. Offer period may be changed or extended at any time. If you tick the box, you agree to receive occasional Lady Bonita exclusive offers by email. You can ask us to stop at any time by contacting info@ladybonita.co.nz. Your personal information will be handled in accordance with the <a href="/policies/privacy-policy" target="_blank" rel="noopener">Lady Bonita Privacy Policy</a>.</p>' +
      '</div>' +
    '</div>';
  }

  function renderPreOrderCard() {
    return '<div class="lb-rf-preorder-card"><h3>Pre-order note</h3><p>Lady Bonita works mainly on a pre-order model. Products are imported weekly and remain subject to availability. Most pre-orders usually take around 7–14 business days from order placement to arrive before NZ dispatch. Once ready, orders are usually sent with NZ Post Courier.</p></div>';
  }

  function renderProductCard(product, section) {
    section = section || "recommended";
    var image = product.image
      ? '<span class="lb-rf-product-fallback" style="display:none;">' + getProductIcon(product) + '</span><img loading="lazy" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title || "Product") + '" onerror="this.style.display=\'none\'; if(this.previousElementSibling){ this.previousElementSibling.style.display=\'flex\'; }">'
      : '<span class="lb-rf-product-fallback">' + getProductIcon(product) + '</span>';
    var meta = [product.vendor, product.priceText, product.available === false ? "Sold out" : ""].filter(Boolean).join(" · ");
    var productId = escapeHtml(product.id || "");
    var variantId = escapeHtml(product.variantId || "");
    var url = escapeHtml(product.url || window.location.origin);
    var title = escapeHtml(product.title || "Product");

    var wishlistHtml = productId && variantId
      ? '<span class="lb-rf-wishlist-wrap"><div class="wishlist-engine" data-product_id="' + productId + '" data-variant_id="' + variantId + '" data-full_button="false" data-css="true"></div></span>'
      : '<button class="lb-rf-heart" type="button" data-lb-rf-heart>♡</button>';

    var qtyHtml = product.available === false ? "" : '<div class="lb-rf-qty" aria-label="Quantity"><button type="button" data-lb-rf-qty-minus aria-label="Decrease quantity">−</button><input type="number" min="1" max="10" value="1" data-lb-rf-qty aria-label="Quantity"><button type="button" data-lb-rf-qty-plus aria-label="Increase quantity">+</button></div>';

    var addButton = product.available === false
      ? '<a class="lb-rf-btn lb-rf-btn-primary" href="' + url + '" data-lb-rf-view-product data-section="' + escapeHtml(section) + '" data-title="' + title + '">View / notify</a>'
      : '<button class="lb-rf-btn lb-rf-btn-primary" type="button" data-lb-rf-add data-section="' + escapeHtml(section) + '" data-variant-id="' + variantId + '" data-title="' + title + '">Add to cart</button>';

    return '<article class="lb-rf-product-card" data-lb-rf-product-card data-section="' + escapeHtml(section) + '" data-variant-id="' + variantId + '" data-title="' + title + '" data-url="' + url + '" data-price="' + escapeHtml(product.priceText || "") + '">' +
      '<span class="lb-rf-step-pill">' + escapeHtml(product.step || product.productType || "Recommended") + '</span>' +
      '<a class="lb-rf-product-image" href="' + url + '" data-lb-rf-view-product data-section="' + escapeHtml(section) + '" data-title="' + title + '">' + image + '</a>' +
      '<h4>' + title + '</h4>' +
      '<div class="lb-rf-meta">' + escapeHtml(meta) + '</div>' +
      '<p>' + escapeHtml(product.reason || product.benefit || "Selected based on your quiz answers.") + '</p>' +
      qtyHtml +
      '<div class="lb-rf-card-actions">' +
        addButton +
        '<a class="lb-rf-btn lb-rf-btn-secondary" href="' + url + '" data-lb-rf-view-product data-section="' + escapeHtml(section) + '" data-title="' + title + '">View</a>' +
        wishlistHtml +
      '</div>' +
    '</article>';
  }

  function getProductIcon(product) {
    var text = normalizeText([product.productType, product.title, product.tags].join(" "));
    if (/cleanser|wash|foam|gel/.test(text)) return iconBottle;
    if (/toner|essence|serum|ampoule|hydr/.test(text)) return iconDrop;
    if (/heartleaf|centella|cica|calm|barrier|cream|moist/.test(text)) return iconHeart;
    if (/bright|glow|vitamin/.test(text)) return iconSparkle;
    return iconBottle;
  }

  async function loadAllProducts() {
    try {
      var cached = sessionStorage.getItem(catalogCacheKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && parsed.time && Array.isArray(parsed.products) && Date.now() - parsed.time < catalogCacheMaxAge) {
          allProducts = parsed.products;
          return parsed.products;
        }
      }
    } catch (error) {}

    var all = [];
    var maxPages = 8;
    var limit = 250;

    for (var page = 1; page <= maxPages; page++) {
      try {
        var response = await fetch("/products.json?limit=" + limit + "&page=" + page, {
          headers: { "Accept": "application/json" }
        });

        if (!response.ok) break;

        var data = await response.json();
        var products = Array.isArray(data.products) ? data.products : [];
        if (!products.length) break;

        all = all.concat(products.map(normalizeShopifyProduct));
        if (products.length < limit) break;
      } catch (error) {
        break;
      }
    }

    allProducts = all;

    try {
      sessionStorage.setItem(catalogCacheKey, JSON.stringify({ time: Date.now(), products: all }));
    } catch (error) {}

    return all;
  }

  function normalizeShopifyProduct(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var availableVariant = variants.find(function (variant) { return variant.available; }) || variants[0] || {};
    var firstImage = product.images && product.images[0] ? product.images[0] : {};
    var image = firstImage.src || firstImage || "";
    var handle = product.handle || getHandleFromUrl(product.url);
    var url = window.location.origin + "/products/" + handle;

    return {
      productKey: handle || String(product.id || product.title),
      id: String(product.id || ""),
      variantId: String(availableVariant.id || ""),
      handle: handle,
      title: product.title || "",
      vendor: product.vendor || "",
      productType: product.product_type || product.type || "",
      priceText: formatMoney(availableVariant.price),
      url: url,
      image: image,
      available: availableVariant.available === true,
      tags: Array.isArray(product.tags) ? product.tags.join(", ") : String(product.tags || ""),
      description: stripHtml(product.body_html || product.description || "").slice(0, 900)
    };
  }

  function selectCandidateProducts(catalog, answers) {
    var scored = catalog.map(function (product) {
      return Object.assign({}, product, { _score: scoreProduct(product, answers) });
    }).filter(function (product) {
      return product._score > 0 && product.title && product.url;
    });

    scored.sort(function (a, b) { return b._score - a._score; });
    var selected = dedupeProducts(scored).slice(0, 90);

    if (selected.length < 10) {
      selected = dedupeProducts(selected.concat(catalog.slice(0, 90))).slice(0, 90);
    }

    return selected.map(function (product) {
      delete product._score;
      return product;
    });
  }

  function scoreProduct(product, answers) {
    var text = getProductText(product);
    var score = 0;
    var skinType = answers.skinType || "";
    var mainConcern = answers.mainConcern || "";
    var productGoal = answers.productGoal || "";
    var routineLevel = answers.routineLevel || "";
    var texture = answers.texture || "";
    var freeNote = normalizeText(answers.freeNote || "");

    if (/sunscreen|spf|sun cream/.test(text)) return -999;
    if (product.available) score += 2;
    if (product.image) score += 1;

    if (skinType === "oily" && /oily|sebum|pore|pores|bha|salicylic|tea tree|niacinamide|acne|blemish|gel|lightweight/.test(text)) score += 12;
    if (skinType === "dry" && /dry|dehydrated|hyaluronic|ceramide|panthenol|moisture|hydrating|cream|barrier|nourishing/.test(text)) score += 12;
    if (skinType === "combination" && /balance|balancing|lightweight|gel|hydrating|toner|essence|serum|combination|sebum/.test(text)) score += 10;

    if (mainConcern === "breakouts" && /acne|blemish|breakout|pimple|spot|patch|salicylic|bha|tea tree|centella|cica|succinic/.test(text)) score += 18;
    if (mainConcern === "hydration" && /hydrating|hydration|hyaluronic|moisture|panthenol|betaine|essence|toner/.test(text)) score += 18;
    if (mainConcern === "brightening" && /bright|glow|vitamin c|niacinamide|dark spot|pigmentation|arbutin|dull/.test(text)) score += 16;
    if (mainConcern === "calm" && /calm|soothing|centella|cica|heartleaf|madecassoside|barrier|panthenol|sensitive/.test(text)) score += 16;
    if (mainConcern === "pores_oil" && /pore|pores|sebum|oil|oily|clay|bha|salicylic|niacinamide|mattifying/.test(text)) score += 16;
    if (mainConcern === "barrier" && /barrier|ceramide|panthenol|cica|centella|moisture|repair|madecassoside/.test(text)) score += 16;
    if (mainConcern === "firmness" && /firm|line|wrinkle|retinol|peptide|collagen|elasticity|anti-aging|anti ageing/.test(text)) score += 14;

    if (answers.sensitivity === "high" && /calm|soothing|heartleaf|centella|cica|barrier|fragrance.?free|sensitive|panthenol|ceramide/.test(text)) score += 14;
    if (answers.sensitivity === "high" && /peeling|aha|bha|retinol|strong|acid|exfoliat/.test(text)) score -= 7;

    if (productGoal === "cleanser" && /cleanser|cleansing|wash|foam/.test(text)) score += 22;
    if (productGoal === "toner_essence" && /toner|essence/.test(text)) score += 22;
    if (productGoal === "serum_ampoule" && /serum|ampoule/.test(text)) score += 22;
    if (productGoal === "moisturiser" && /moisturi|cream|lotion|gel cream/.test(text)) score += 22;
    if (productGoal === "mask_patch" && /mask|patch|spot/.test(text)) score += 22;
    if (productGoal === "full_routine" && /cleanser|toner|essence|serum|ampoule|moisturi|cream|mask|patch/.test(text)) score += 10;

    if (texture === "lightweight" && /lightweight|watery|gel|fresh|non-sticky|non sticky|ampoule|essence|toner/.test(text)) score += 8;
    if (texture === "nourishing" && /cream|rich|nourishing|barrier|ceramide|balm|butter/.test(text)) score += 8;

    if (/morning|am|daytime/.test(freeNote) && /lightweight|gel|toner|essence|fresh/.test(text)) score += 4;
    if (/night|pm|evening|overnight/.test(freeNote) && /serum|ampoule|mask|patch|cream|barrier|treatment/.test(text)) score += 5;
    if (/patch|pimple|spot/.test(freeNote) && /patch|pimple|spot|acne/.test(text)) score += 20;

    if (routineLevel === "simple" && /cleanser|serum|moisturi|cream/.test(text)) score += 4;
    if (routineLevel === "full" && /toner|essence|ampoule|mask|patch|eye|lip/.test(text)) score += 4;

    return score;
  }

  function dedupeProducts(products) {
    var seen = {};
    var output = [];
    products.forEach(function (product) {
      var key = product.handle || product.url || product.title;
      if (!key || seen[key]) return;
      seen[key] = true;
      output.push(product);
    });
    return output;
  }

  function collectRecommendedProducts(result) {
    var products = [];
    ["mainRoutineProducts", "youMayAlsoLikeProducts", "brandProducts", "pairingProducts"].forEach(function (key) {
      if (Array.isArray(result[key])) products = products.concat(result[key]);
    });
    if (Array.isArray(result.pairingSets)) {
      result.pairingSets.forEach(function (set) {
        if (Array.isArray(set.products)) products = products.concat(set.products);
      });
    }
    return dedupeProducts(products);
  }

  function clampQuantity(value) {
    var qty = parseInt(value, 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    if (qty > 10) qty = 10;
    return qty;
  }

  function changeQuantity(button, direction) {
    var card = button.closest("[data-lb-rf-product-card]");
    var input = card ? card.querySelector("[data-lb-rf-qty]") : null;
    if (!input) return;
    input.value = clampQuantity(Number(input.value || 1) + direction);
  }

  function getCardQuantity(card) {
    var input = card ? card.querySelector("[data-lb-rf-qty]") : null;
    return clampQuantity(input ? input.value : 1);
  }

  function getCurrentEmail() {
    var saveInput = root.querySelector("[data-lb-rf-save-email-input]");
    var initialInput = root.querySelector("[data-lb-rf-email]");
    var email = saveInput && saveInput.value ? saveInput.value.trim() : "";
    if (!email && initialInput && initialInput.value) email = initialInput.value.trim();
    return email;
  }

  function buildCartAttributes(email) {
    return {
      "Routine Finder Source": "routine_finder_ai",
      "Routine Finder Session ID": sessionId,
      "Routine Finder Conversation ID": conversationId,
      "Routine Finder Email": email || "",
      "Routine Finder Page": window.location.href
    };
  }

  function buildLineItemProperties(email, section) {
    return {
      "_Routine Finder": "Yes",
      "_Quiz Session ID": sessionId,
      "_Quiz Conversation ID": conversationId,
      "_Quiz Email": email || "",
      "_Quiz Page": window.location.href,
      "_Quiz Section": section || ""
    };
  }

  async function markCartAttributes(email) {
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: buildCartAttributes(email || "") })
      });
    } catch (error) {}
  }

  async function addSingleToCart(button) {
    var card = button.closest("[data-lb-rf-product-card]");
    var variantId = button.getAttribute("data-variant-id");
    var title = button.getAttribute("data-title") || (card ? card.getAttribute("data-title") : "") || "";
    var productUrl = card ? card.getAttribute("data-url") || "" : "";
    var section = card ? card.getAttribute("data-section") || "" : "";
    var price = card ? card.getAttribute("data-price") || "" : "";
    var quantity = getCardQuantity(card);
    var email = getCurrentEmail();

    if (!variantId) {
      alert("Please view " + (title || "this product") + " to check current availability.");
      return;
    }

    button.disabled = true;
    button.textContent = "Adding...";

    try {
      await markCartAttributes(email);

      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity,
          properties: buildLineItemProperties(email, section)
        })
      });

      if (!response.ok) throw new Error("Cart add failed");

      button.textContent = "Added ✓";
      refreshCartUI();

      setTimeout(function () {
        button.disabled = false;
        button.textContent = "Add to cart";
      }, 1600);

      trackQuizEvent("quiz_add_to_cart", {
        productTitle: title,
        productUrl: productUrl,
        customerEmail: email,
        notes: JSON.stringify({
          variantId: variantId,
          quantity: quantity,
          section: section,
          price: price,
          source: "single_add"
        })
      });
    } catch (error) {
      button.disabled = false;
      button.textContent = "Try again";
    }
  }

  async function addAllMainRoutine(button) {
    var email = getCurrentEmail();
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-lb-rf-main-grid] [data-lb-rf-product-card]"));
    var items = cards.map(function (card) {
      var variantId = card.getAttribute("data-variant-id") || "";
      var section = card.getAttribute("data-section") || "main_routine";
      var quantity = getCardQuantity(card);

      if (!variantId) return null;

      return {
        id: Number(variantId),
        quantity: quantity,
        properties: buildLineItemProperties(email, section),
        _analytics: {
          title: card.getAttribute("data-title") || "",
          url: card.getAttribute("data-url") || "",
          variantId: variantId,
          quantity: quantity,
          section: section,
          price: card.getAttribute("data-price") || ""
        }
      };
    }).filter(Boolean);

    if (!items.length) {
      alert("No available products were ready to add. Please view the products to check current availability.");
      return;
    }

    button.disabled = true;
    button.textContent = "Adding...";

    try {
      await markCartAttributes(email);

      var cartItems = items.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties
        };
      });

      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: cartItems })
      });

      if (!response.ok) throw new Error("Cart add failed");

      button.textContent = "Added ✓";
      refreshCartUI();

      setTimeout(function () {
        button.disabled = false;
        button.textContent = "Add selected to cart";
      }, 1800);

      trackQuizEvent("quiz_add_all_to_cart", {
        customerEmail: email,
        productTitle: "Full routine",
        notes: JSON.stringify({ items: items.map(function (item) { return item._analytics; }) })
      });

      items.forEach(function (item) {
        trackQuizEvent("quiz_add_to_cart", {
          productTitle: item._analytics.title,
          productUrl: item._analytics.url,
          customerEmail: email,
          notes: JSON.stringify(Object.assign({}, item._analytics, { source: "add_selected_routine" }))
        });
      });
    } catch (error) {
      button.disabled = false;
      button.textContent = "Try again";
    }
  }

  function refreshCartUI() {
    try {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      window.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (error) {}
  }

  async function requestEmailResult(button) {
    var input = root.querySelector("[data-lb-rf-save-email-input]") || root.querySelector("[data-lb-rf-email]");
    var consentInput = root.querySelector("[data-lb-rf-marketing-consent]");
    var email = input ? input.value.trim() : "";
    var marketingConsent = Boolean(consentInput && consentInput.checked === true);
    var status = root.querySelector("[data-lb-rf-save-status]");
    lastMarketingConsent = marketingConsent;
    lastMarketingConsentTimestamp = marketingConsent ? new Date().toISOString() : "";

    if (!email || !isValidEmail(email)) {
      if (status) status.textContent = "Please enter a valid email address.";
      var saveCard = root.querySelector(".lb-rf-save-card");
      if (saveCard) saveCard.scrollIntoView({ behavior: "smooth", block: "center" });
      if (input) input.focus();
      return;
    }

    if (!lastResult) {
      if (status) status.textContent = "Please generate your routine first.";
      return;
    }

    button.disabled = true;
    button.textContent = "Sending...";

    try {
      await markCartAttributes(email);
      await sendQuizEmail(email, marketingConsent);
      button.textContent = "Sent ✓";
      if (status) status.textContent = marketingConsent ? "Your routine has been sent. You’re also signed up for Lady Bonita beauty emails." : "Your routine has been sent to your email.";
      setTimeout(function () {
        button.disabled = false;
        button.textContent = "Email my routine";
      }, 1800);
    } catch (error) {
      button.disabled = false;
      button.textContent = "Email my routine";
      if (status) status.textContent = "Sorry, we could not send it just now. Please try again.";
    }
  }

  async function sendQuizEmail(email, marketingConsent) {
    var payload = buildQuizResultPayload("quiz_email_requested", email, marketingConsent);
    var consentAccepted = Boolean(marketingConsent === true || lastMarketingConsent === true);
    var consentMeta = {
      marketingConsent: consentAccepted,
      consentTimestamp: consentAccepted ? (lastMarketingConsentTimestamp || new Date().toISOString()) : "",
      consentSource: consentAccepted ? "Routine Finder" : "",
      discountOffer: "5% off",
      discountMinimum: "$99"
    };

    payload.marketingConsent = consentAccepted;
    payload.consentTimestamp = consentMeta.consentTimestamp;
    payload.consentSource = consentMeta.consentSource;
    payload.discountOffer = consentMeta.discountOffer;
    payload.discountMinimum = consentMeta.discountMinimum;
    payload.notes = JSON.stringify(consentMeta);
    payload.feedback = JSON.stringify(consentMeta);

    var response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.assign({ mode: "analytics" }, payload))
    });

    var data = await response.json();
    if (!response.ok || !data.ok) throw new Error("Email request failed");

    trackQuizEvent("quiz_email_saved", {
      customerEmail: email,
      marketingConsent: Boolean(marketingConsent),
      consentTimestamp: marketingConsent ? (lastMarketingConsentTimestamp || new Date().toISOString()) : "",
      consentSource: marketingConsent ? "Routine Finder" : "",
      discountOffer: "5% off",
      discountMinimum: "$99",
      notes: JSON.stringify({
        action: "Routine email requested",
        marketingConsent: Boolean(marketingConsent),
        discountOffer: "5% off",
        discountMinimum: "$99"
      })
    });
  }

  function buildQuizResultPayload(eventType, email, marketingConsent) {
    var result = lastResult || {};
    var consentAccepted = Boolean(marketingConsent === true || lastMarketingConsent === true);
    var consentTimestamp = consentAccepted ? (lastMarketingConsentTimestamp || new Date().toISOString()) : "";

    return {
      eventType: eventType,
      sessionId: sessionId,
      conversationId: conversationId,
      customerEmail: email || "",
      skinType: answers.skinType || "",
      mainConcern: answers.mainConcern || "",
      sensitivity: answers.sensitivity || "",
      productGoal: answers.productGoal || "",
      routineLevel: answers.routineLevel || "",
      texture: answers.texture || "",
      freeNote: answers.freeNote || "",
      aiSkinProfile: result.aiSkinProfile || "",
      mainRoutineProducts: result.mainRoutineProducts || [],
      youMayAlsoLikeProducts: result.youMayAlsoLikeProducts || [],
      pairingProducts: result.pairingProducts || [],
      brandProducts: result.brandProducts || [],
      amPmNotes: result.amPmNotes || "",
      feedback: JSON.stringify({
        marketingConsent: consentAccepted,
        consentTimestamp: consentTimestamp,
        consentSource: consentAccepted ? "Routine Finder" : "",
        discountOffer: "5% off",
        discountMinimum: "$99"
      }),
      notes: JSON.stringify({
        marketingConsent: consentAccepted,
        consentTimestamp: consentTimestamp,
        consentSource: consentAccepted ? "Routine Finder" : "",
        discountOffer: "5% off",
        discountMinimum: "$99"
      }),
      marketingConsent: consentAccepted,
      consentTimestamp: consentTimestamp,
      consentSource: consentAccepted ? "Routine Finder" : "",
      discountOffer: "5% off",
      discountMinimum: "$99",
      pageUrl: window.location.href
    };
  }

  async function trackQuizEvent(eventType, extra) {
    var payload = Object.assign({
      mode: "analytics",
      eventType: eventType,
      sessionId: sessionId,
      conversationId: conversationId,
      customerEmail: "",
      pageUrl: window.location.href
    }, extra || {});

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
    } catch (error) {}
  }

  function toggleLocalWishlist(button) {
    button.classList.toggle("is-active");
    button.textContent = button.classList.contains("is-active") ? "♥" : "♡";
    trackQuizEvent("quiz_wishlist_click", {
      notes: "Local wishlist fallback clicked"
    });
  }

  function showMoreProducts(button) {
    var row = root.querySelector("[data-lb-rf-more-row]");
    if (!row || !lastResult) return;

    var existingCount = row.children.length;
    var remaining = recommendedProducts.slice(existingCount, existingCount + 6);

    if (!remaining.length) {
      button.textContent = "No more for now";
      button.disabled = true;
      return;
    }

    row.insertAdjacentHTML("beforeend", remaining.map(function (product) { return renderProductCard(product, "show_more"); }).join(""));
    initWishlistEngine();

    trackQuizEvent("quiz_show_more", {
      notes: JSON.stringify({ shown: remaining.length })
    });
  }

  function renderDemoResult() {
    lastResult = {
      aiSkinProfile: "A lightweight routine focused on keeping skin fresh, balanced and comfortable, with extra support for shine and occasional blemishes.",
      safetyNote: "General guidance only. Not clinical advice. Product information may be updated by the manufacturer, so please check product pages and packaging for the latest instructions and ingredients. Patch test skincare before use.",
      amPmNotes: "For morning, keep the routine light and use your preferred sunscreen separately. For evening, focus on treatment products, hydration support, masks or patches.",
      mainRoutineProducts: [
        { step: "Step 1 · Cleanse", title: "Cleanser match", vendor: "Lady Bonita", priceText: "Product from catalogue", url: window.location.origin, image: "", available: true, reason: "A gentle start to help keep the routine fresh and easy." },
        { step: "Step 2 · Treat", title: "Serum or ampoule match", vendor: "Lady Bonita", priceText: "Product from catalogue", url: window.location.origin, image: "", available: true, reason: "Chosen to target your main concern without feeling too heavy." },
        { step: "Step 3 · Moisturise", title: "Moisture support match", vendor: "Lady Bonita", priceText: "Product from catalogue", url: window.location.origin, image: "", available: true, reason: "Helps finish the routine with comfort and balance." }
      ],
      youMayAlsoLikeProducts: [],
      pairingSets: [],
      brandProducts: []
    };

    selectedMainRoutine = lastResult.mainRoutineProducts;
    recommendedProducts = selectedMainRoutine;
    renderResult(lastResult, "");

    var resultsPanel = root.querySelector("[data-lb-rf-results]");
    if (resultsPanel) resultsPanel.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function initWishlistEngine() {
    try {
      document.dispatchEvent(new CustomEvent("wishlist-engine:refresh"));
      window.dispatchEvent(new CustomEvent("wishlist-engine:refresh"));
    } catch (error) {}

    try {
      if (window.WishlistEngine && typeof window.WishlistEngine.init === "function") window.WishlistEngine.init();
    } catch (error) {}

    try {
      if (window.wishlistEngine && typeof window.wishlistEngine.init === "function") window.wishlistEngine.init();
    } catch (error) {}

    try {
      if (window.SEWishlist && typeof window.SEWishlist.init === "function") window.SEWishlist.init();
    } catch (error) {}

    try {
      if (window.SEWishlistEngine && typeof window.SEWishlistEngine.init === "function") window.SEWishlistEngine.init();
    } catch (error) {}
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || ""));
  }

  function restoreResult() {
    try {
      var raw = sessionStorage.getItem(resultStateKey);
      if (!raw) return;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.result || Date.now() - Number(parsed.time || 0) > 60 * 60 * 1000) return;

      lastResult = parsed.result;
      answers = parsed.answers || {};
      selectedMainRoutine = Array.isArray(lastResult.mainRoutineProducts) ? lastResult.mainRoutineProducts : [];
      recommendedProducts = collectRecommendedProducts(lastResult);
      renderResult(lastResult, parsed.email || "");
    } catch (error) {}
  }

  renderShell();
  bindEvents();
  updateStep();
  restoreResult();
  trackQuizEvent("quiz_loaded", { notes: "Routine Finder loaded" });
})();
